import { normalize, denormalize, schema } from 'normalizr';
export { normalize, denormalize, schema };
//# sourceMappingURL=index.js.map